import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SHEIN_URL = 'https://shein.com';

const ShopAbroadSheinPage = () => {
  const navigate = useNavigate();
  const [blocked, setBlocked] = useState(false);

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <div className="flex items-center gap-3 px-3 py-3 border-b border-border bg-background">
        <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div className="flex flex-col leading-tight">
          <span className="text-base font-semibold">SHEIN</span>
          <span className="text-[10px] text-muted-foreground">Powered by GAMBGO</span>
        </div>
      </div>

      <div className="flex-1 relative">
        {!blocked ? (
          <iframe
            src={SHEIN_URL}
            title="SHEIN"
            className="absolute inset-0 w-full h-full border-0"
            onError={() => setBlocked(true)}
            onLoad={(e) => {
              // Best-effort: if cross-origin frame fails to expose contentDocument it's still loaded
              try {
                const doc = (e.target as HTMLIFrameElement).contentDocument;
                if (!doc) return;
              } catch {
                // ignore
              }
            }}
          />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center gap-4">
            <p className="text-sm text-muted-foreground">
              SHEIN can't be embedded in this preview. In the GAMBGO app it opens directly.
            </p>
            <Button onClick={() => window.open(SHEIN_URL, '_blank')}>
              <ExternalLink className="h-4 w-4 mr-2" />
              Open SHEIN
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopAbroadSheinPage;
